import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, timeout } from 'rxjs';
import { Reclamation } from '../../../reclamation/models/reclamation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from '../../../auth/models/user.model';
import { TokenStorageService } from '../../../auth/services/token-storage.service';
import { UserService } from '../../../auth/services/user.service';
import { ReclamationService } from '../../../reclamation/services/reclamation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommunService } from '../../../../shared/services/commun';
import { MotifreclamationService } from '../../../../shared/services/motifreclamation';
import { dataService } from '../../../../shared/services/data.service';
import Swal from 'sweetalert2';
import { Sort } from '../../../../shared/_helpers/sort';
import { datacommService } from '../../../../shared/services/datacomm.service';
import { Chargeback } from '../../../reclamation/models/chargeback.model';
import { ChargebackService } from '../../../reclamation/services/chargeback.service';
import { PageEvent } from '@angular/material/paginator';
import { DelaisService } from 'src/app/shared/services/delaisdepasse.service';
@Component({
  selector: 'app-user-board',
  templateUrl: './user-board.component.html',
  styleUrls: ['./user-board.component.scss']
})
export class UserBoardComponent implements OnInit,OnDestroy {
  @ViewChild('filePicker', { static: false }) filePicker: ElementRef<HTMLInputElement>;
  public filtredusers: User[] = [];
  prenom:string;
  nom:string
  role: string;
  isLoggedIn = false;
  private reclamationsSub: Subscription;
  public reclamation: Reclamation;
  public errormsg:string;
  public loading: boolean;
  usertype: string;
  email: string;
  userId:string;
  converteddate: Date;
  converteddate2: Date;
  public reclamations: Reclamation[] = [];
  reclamationnumber=0;
  banque: string;
  reclamationsacqSub: Subscription;
  reclamationsacq: Reclamation[]=[];
  reclamationsemeSub: Subscription;
  reclamationseme: Reclamation[]=[];
  reclamationsonus: Reclamation[]=[];
  filtreditemschecked: any[]=[];
  displaybox='none';
  public reclamationform: FormGroup; 
  submitted=false;
  transactions: any[];
  imagePreview: string;
  fileUploaded: boolean;
  motifsub: Subscription;
  motifs=[]
  familles: any[]=[];
  groupes: any=[];
  settedfamilles: any[]=[];
  settedgroupes: any=[];
  settedmotifs: any[]=[];
   showreclamationsacq=false;
   showreclamationseme=false;
   showreclamations=false;
   showreclamationsonus=false;
  cartes: any[]=[];
  user: User;
  reclamationscomite: any[]=[];
  reclamationsonusSub: Subscription;
  allreclamationsSub: Subscription;
  public option0Value:any
  public option1Value:any
  public option2Value:any
  public option3Value:any
  public option4Value:any
  public option5Value:any
  public option6Value:any
  public option7Value:any
  public option8Value:any
  public option9Value:any
  public option10Value:any
  public option11Value:any
  public option12Value:any
  public option13Value:any
  public status=[];
  uploadedfiles: any[]=[];
  showfilterbutton=true;
  showreinitbutton=false;
  showvalidationbutton: boolean;
  showform=false;
  selectedaction='';
  showmotif: boolean;
  showsearchform=true;
  availablesmotifs: any[];
  MS_PER_DAY = 24 * 3600 * 1000; // Milliseconds per day
  currentdate: number;
  paginatedreclamations = []; // The displayed list after pagination
  paginatedreclamationsonus = []; // The displayed list after pagination
  paginatedreclamationsacq = []; // The displayed list after pagination
  paginatedreclamationscomite = []; // The displayed list after pagination
  paginatedreclamationseme = []; // The displayed list after pagination
  itemsPerPage = 50; // Default items per page
  currentPage = 0; // Default to the first page
  motifsrechdoc=[];
  modeworkflow=[];
  actiondate: number;

  constructor(private mot: MotifreclamationService,         
    private Auth: TokenStorageService,
    private recserv:ReclamationService,
    private router: Router,
    private route: ActivatedRoute,
    private UserService: UserService,private authorizeconsult:DelaisService,
    private formBuilder: FormBuilder,private chargebackservice: ChargebackService,
    private commun: CommunService,private datacomm: datacommService,private data: dataService,

    ) { }
  executebatch()
    {
      this.loading=true
      this.commun.executebatch(new Date(this.currentdate)).then(
        (data:any) => {
          this.loading = false;
   // Show success message
   Swal.fire({
    position: 'center',
    icon: 'success',
    title: 'batch exécuté avec succès!',
    showConfirmButton: false,
    timer: 6000
  });
  this.refreshrecs()
        },
        (error) => {
          this.loading = false;   
        } 
      );
    }
     // This method updates the paginated list based on the current page and items per page
  updatePaginatedList(list:any) {
    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    if(list==this.reclamationseme)
{
  this.paginatedreclamationseme = this.reclamationseme.slice(startIndex, endIndex);
console.log(this.reclamationseme)
console.log(this.paginatedreclamationseme)
}
else if(list==this.reclamationsonus)
{
  this.paginatedreclamationsonus = this.reclamationsonus.slice(startIndex, endIndex);
}
else if(list==this.reclamationsacq)
{
  this.paginatedreclamationsacq = this.reclamationsacq.slice(startIndex, endIndex);
}
else if(list==this.reclamationscomite)
{
  this.paginatedreclamationscomite = this.reclamationscomite.slice(startIndex, endIndex);
}
else if(list==this.reclamations)
{
  this.paginatedreclamations = this.reclamations.slice(startIndex, endIndex);
}
  }

  // This method is called whenever the page is changed
  onPageChange(event: PageEvent,list:any) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.updatePaginatedList(list);
  }
  ngOnInit() {
    const sort = new Sort();
      const currentuser = this.Auth.getUser();
      this.reclamationform = this.formBuilder.group({                
        commentaire:'',
        motif: '',
        groupe: '',
        famille: '',
        file: '',
      }); 
      this.motifsub = this.mot.motifreclamations$.subscribe(
        (motifs) => {
          motifs[0].currentdate?this.currentdate = motifs[0].currentdate:this.currentdate = new Date().getTime();
          this.motifs = motifs;
          motifs.forEach(e=>e.groupe.forEach(el=>(this.familles.push(
          //@ts-ignore
           {
          //@ts-ignore
    groupe:el.groupe,
         //@ts-ignore
    fam:el.famille
           } ),
         //@ts-ignore
           this.groupes.push(el.groupe)
          //@ts-ignore
          ,this.motifs.push({id:el.code,intitule:el.motif,fam:el.famille}),
          this.motifsrechdoc.push({
                  //@ts-ignore
    code:el.code,
    //@ts-ignore
    rechdocpresentation:el.rechdocpresentation
          }),
          this.modeworkflow.push({
            //@ts-ignore
            code:el.code,
            //@ts-ignore
            mode:el.collaballoc
          }))))
         /* this.settedfamilles= this.familles.filter((obj, index) => {
            return index === this.familles.findIndex(o => obj === o);
          });
          this.settedfamilles=this.settedfamilles.sort()*/
          this.settedgroupes= this.groupes.filter((obj, index) => {
            return index === this.groupes.findIndex(o => obj === o);
          });
       //   this.settedgroupes=this.settedgroupes.sort() 
          this.settedgroupes=this.settedgroupes.filter(e=>e!='tout type')
         /* this.settedmotifs= this.motifs.filter((obj, index) => {
            return index === this.motifs.findIndex(o => obj.id === o.id);
          });
          this.settedmotifs=this.settedmotifs.sort()*/
        }
      )
      this.status=this.commun.statuts
      this.UserService.getUserById(currentuser.userId).then(
        (user:User) => {
          this.user=user
          this.usertype = user.usertype;
          this.email = user.email;
          this.userId = user._id;
          this.role=user.role;
          this.prenom=user.firstname
          this.nom=user.lastname
          this.banque=user.banque
        this.loading = true;
        if (user.usertype=='Clientcomm'&&!user.compte&&!user.affiliation&&!user.terminal
        ||user.usertype=='Clientpor'&&!user.carte||user.usertype=='Clientpor'&&!user.compte) 
        return (Swal.fire(
user.usertype=='Clientcomm'&&!user.compte&&!user.affiliation&&!user.terminal?'veuillez renseigner votre numéro de compte ou numéro d\'affiiation ou numéro terminal':
user.usertype=='Clientpor'&&!user.carte||user.usertype=='Clientpor'&&!user.compte?'veuillez renseigner votre numéro de compte ou numéro de carte':''),
         this.router.navigate(['auth/complete-profil/'+currentuser.userId]))  
         //get all reclamations
         this.allreclamationsSub = this.recserv.allreclamations$.subscribe(
          (reclamations) => {
            //@ts-ignore
            this.reclamationscomite=reclamations.filter(tra=>tra.transactions[0].ACQUIRERBANKIDENTIFICATION!=user.banque&&tra.transactions[0].ISSUERBANKIDENTIFICATION!=user.banque).filter(e=>e.statut.length>0).filter(el=>el.statut.find(element=>element.item=='arbitrage'))
            this.showdeadline(this.reclamationscomite)
            this.updatePaginatedList(this.reclamationscomite);
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        );  
        //get onus reclamations
        this.reclamationsonusSub = this.recserv.reclamationsonus$.subscribe(
          (reclamations) => {
            //this.showreclamationsonus=true
            this.reclamationsonus=reclamations
            this.showdeadline(this.reclamationsonus)
            this.updatePaginatedList(this.reclamationsonus);

            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        );  
        const sort = new Sort();
        //get eme reclamations
        this.reclamationsemeSub = this.recserv.reclamationseme$.subscribe(
          (reclamations) => {
           // this.showreclamationseme=true
            this.reclamationseme=reclamations
            this.reclamationseme=this.reclamationseme
            this.showdeadline(this.reclamationseme)
            this.updatePaginatedList(this.reclamationseme);

            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        );
        //get acq reclamations
        this.reclamationsacqSub = this.recserv.reclamationsacq$.subscribe(
          (reclamations) => {
           // this.showreclamationsacq=true
            //@ts-ignore
            this.reclamationsacq=reclamations.filter(e=>e.statut.length>0).filter(el=>el.statut.find(e=>e.item=='chb émis'||e.item=='rechdoc'))
            this.showdeadline(this.reclamationsacq)
            this.updatePaginatedList(this.reclamationsacq);
           this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        );          
        user.usertype=='Clientpor'? this.reclamationsSub = this.recserv.reclamationsportbanque$.subscribe(
          (reclamations) => {
            this.reclamations = reclamations;
            this.showdeadline(this.reclamations)
            this.updatePaginatedList(this.reclamations);
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        ):
        user.usertype=='Clientcomm'? this.reclamationsSub = this.recserv.reclamationscomm$.subscribe(
          (reclamations) => {
            reclamations.forEach(
              e=>
              {
                if(e.statut.length>0)
                {
                  //@ts-ignore
                  if(e.statut.find(e=>e.etat=='notification commerçant'))
                  {
this.reclamations.push(e)
                  }
                }
              }
            )
            this.updatePaginatedList(this.reclamations);
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errormsg=error.message;
          }
        ):''
        user.usertype=='Clientpor'||user.usertype=='Clientcomm'?this.showreclamations=true:''
        user.usertype=='Clientpor'?this.data.getmanyinfo(user.compte).then(
          (res:any)=>{
res.forEach(element => {
  this.cartes.push(element.carte)
});
            //this.displaysearch="block"
            this.recserv.getReclamationportbanque(this.cartes)
          }
         ).catch(() => {
          Swal.fire('numéro de compte non renseigné!')
        }):''
        user.usertype=='Clientcomm'?
this.datacomm.getmanyinfo(user.compte||user.affiliation||user.terminal).then(
  (resp:any)=>
  {
this.recserv.getReclamationcomm(resp).catch(() => {
  Swal.fire('numéro de compte non renseigné!')
})
  }
)
:''
        user.usertype=='Metier'||user.usertype=='agence'?( this.recserv.getReclamationacq(this.banque),
        this.recserv.getReclamationeme(this.banque),this.recserv.getReclamationonus(this.banque)):''
        user.usertype=='comite arbitrage'?(this.recserv.getReclamations(),this.mot.getmotifreclamationss()):''
        this.recserv.getReclamation(this.userId);
        this.mot.getmotifreclamationss()
        this.route.params.subscribe(
          params => {
            console.log('user de type'+this.usertype)
            if(this.usertype=='Metier')
            {
              switch(params['type'])
              {
                case 'onus':
                  this.showreclamationsonus=true
                  this.showreclamationseme=false
                  this.showreclamationsacq=false
    
                  break;
                  case 'eme':
                    this.showreclamationseme=true
                    this.showreclamationsonus=false
                    this.showreclamationsacq=false
    
                  break;
                  case 'acq':
                    this.showreclamationsacq=true
                    this.showreclamationseme=false
                    this.showreclamationsonus=false
    
                  break;
                  default:
                        this.showreclamationsonus=true;
                        this.showreclamationseme=true;
                        this.showreclamationsacq=true;              
              }
            }
  
          }
        )
        }
      )

  
  }
  get f() { return this.reclamationform.controls; }
  getNavigation(link, id){
    let allrecs=[]
    allrecs=allrecs.concat(this.reclamations,this.reclamationsacq,this.reclamationseme,this.reclamationsonus,this.reclamationscomite)
    let rec=allrecs.find(e=>e._id==id)
this.authorizeconsult.Authorize(this.user,rec,this.currentdate,this.motifs,link)
  }
  /*verifycapabilitytodecideactioncomite():boolean
  {
    let rec=this.filtreditemschecked[0]
    let filtredstatus=rec.statut.filter(el=>!el.etat)
    if(this.user.usertype=='comite arbitrage')
    {
// this.reclamationsacq=reclamations.filter(e=>e.statut.length>0).filter(e=>e.statut[e.statut.length-1].item=='chb émis'||e.statut[e.statut.length-1].item=='pré-arbitrage')
if(filtredstatus[filtredstatus.length-1].item!='chb émis'&&filtredstatus[filtredstatus.length-1].item!='pré-arbitrage'&&filtredstatus[filtredstatus.length-1].item!='arbitrage')
              {
                return false
              }
              else
              {
                return true
              }
    }
  }*/
  verifycapabilitytodecideaction():boolean
  {
    let rec=this.filtreditemschecked[0]
    let filtredstatus=rec.statut.filter(el=>!el.etat)
let iss=rec.transactions[0].ISSUERBANKIDENTIFICATION
let acq=rec.transactions[0].ACQUIRERBANKIDENTIFICATION
    if(iss!=acq)
    {
      if(this.user.banque==iss)
      {
if(filtredstatus[filtredstatus.length-1].item=='chb émis'||filtredstatus[filtredstatus.length-1].item=='pré-arbitrage'||filtredstatus[filtredstatus.length-1].item=='arbitrage')
                {
                  return false
                }
else if(filtredstatus[filtredstatus.length-1].item=='arbitrage rejeté')
              {
                return false
              }
                else
                {
                  return true 
                }
      }
      else  if(this.user.banque==acq)
      {
// this.reclamationsacq=reclamations.filter(e=>e.statut.length>0).filter(e=>e.statut[e.statut.length-1].item=='chb émis'||e.statut[e.statut.length-1].item=='pré-arbitrage')
if(filtredstatus[filtredstatus.length-1].item!='chb émis'&&filtredstatus[filtredstatus.length-1].item!='pré-arbitrage'&&filtredstatus[filtredstatus.length-1].item!='arbitrage')
                {
                  return false
                }
                else
                {
                  return true
                }
      }
      else{
        return true
      }
    }
    else{
      return true
    }
  }

  calculatereturnedandremainingdays(daterepresentation: number, parameter: number) {
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
  
    const normalizeToMidnight = (date: number): number => {
      const d = new Date(date);
      return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    };
  
    const normalizedDateRepresentation = normalizeToMidnight(daterepresentation);
    const returnedDate = normalizedDateRepresentation + parameter * MS_PER_DAY;
    const normalizedCurrentDate = normalizeToMidnight(this.currentdate);
    const remainingDays = Math.max(0, Math.ceil((returnedDate - normalizedCurrentDate) / MS_PER_DAY));
  
    return { returneddate: returnedDate, remainingdays: remainingDays };
  }
 /* getspecificstatus(rec: Reclamation, rank:number): any
  {
//@ts-ignore
const allstatus = rec.statut.filter(e => !e.etat);
const specifcistatus= allstatus[(allstatus.length)-rank]
//@ts-ignore
let item=specifcistatus.item
//@ts-ignore
return {item}
  }*/
  calculatedeadline(rec: Reclamation): any {
    //@ts-ignore
    const allstatus = rec.statut.filter(e => !e.etat);
    //@ts-ignore
    const transaction = rec.transactions[0]
    const currentdate = this.currentdate;
    let remainingdays = 1, returneddate: any;
  
    const getStatusDate = (item: string, role?: string): number => {
          //@ts-ignore
      const status = allstatus.find(s => s.item === item && (!role || s.role === role));
          //@ts-ignore
      return status ? status.date : currentdate;
    };
  
    const calculateDays = (statusItem: string, motifProp: keyof any) => {
      const date = getStatusDate(statusItem?.toString());
      const days = this.motifs[0]?.[motifProp] || 1;
      return this.calculatereturnedandremainingdays(date, days);
    };
  
    if (allstatus.length > 0) {
          //@ts-ignore
      const lastStatusItem = allstatus[allstatus.length - 1].item;
            //@ts-ignore
      const previouslastStatusItem = allstatus[allstatus.length - 2]?.item;
                  //@ts-ignore
      const prepreviouslastStatusItem = allstatus[allstatus.length - 3]?.item;
                        //@ts-ignore
      const preprepreviouslastStatusItem = allstatus[allstatus.length - 4]?.item;
      //@ts-ignore
      const lastStatusrole = allstatus[allstatus.length - 1].role;
          //@ts-ignore
      const transactionCode = rec.transactions[0].TRANSACTIONCODE;
  
      if (lastStatusItem == 'crée') {
        ({ returneddate, remainingdays } = calculateDays('crée', 'creerec'));
      } 
      else if (lastStatusItem === 'rechdoc') {
        ({ returneddate, remainingdays } = calculateDays('rechdoc', 'initrech'));
      } 
      else if (lastStatusItem === 'reponserechdoc') {
        ({ returneddate, remainingdays } = calculateDays('rechdoc', 'initrech'));
      } 
      //@ts-ignore
  else if (lastStatusItem === 'rejetée'&&lastStatusrole=='émetteur') {
            ({ returneddate, remainingdays } = calculateDays('rejetée', 'relancerec'));
          }
      //@ts-ignore
      else if (lastStatusItem === 'relancée') {
        ({ returneddate, remainingdays } = calculateDays('relancée', 'relancerec'));
      }
      else if (lastStatusItem === 'chb émis') {
            //@ts-ignore
        const motif = allstatus[allstatus.length - 1].motif.substring(0, 4);
        const delai2 = this.motifs[0]?.groupe.find(ele => ele.code === motif)?.delai2 || 1;
  
        if (['05', '06', '07', '08'].includes(transactionCode)) {
          ({ returneddate, remainingdays } = this.calculatereturnedandremainingdays(getStatusDate('chb émis'), delai2));
        }
      } else if (lastStatusItem === 'rejetée'&&lastStatusrole=='acquireur'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='rejetée'&&preprepreviouslastStatusItem=='chb émis') {
        ({ returneddate, remainingdays } = this.calculatereturnedandremainingdays(getStatusDate('rejetée', 'acquireur'), this.motifs[0]?.initprearb));
      } else if (lastStatusItem === 'pré-arbitrage') {
        ({ returneddate, remainingdays } = calculateDays('pré-arbitrage', 'repprearb'));
      } else if (lastStatusItem === 'pré-arbitrage rejetée'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='pré-arbitrage rejetée') {
        ({ returneddate, remainingdays } = calculateDays('pré-arbitrage rejetée', 'initarb'));
      } else if (lastStatusItem === 'arbitrage') {
        ({ returneddate, remainingdays } = calculateDays('arbitrage', 'initcomite'));
      } else if (lastStatusItem === 'arbitrage rejeté'||lastStatusItem === 'relancée'&&previouslastStatusItem=='rejetée'&&prepreviouslastStatusItem=='arbitrage rejeté') {
        ({ returneddate, remainingdays } = calculateDays('arbitrage', 'initcomite'));
      }
      else {
        remainingdays = 0;
      }
    }
  
    return { returneddate, remainingdays };
  }
  
showdeadline(listraclamations:Reclamation[])
  {
 
if(listraclamations==this.reclamationseme)
{
  this.reclamationseme.forEach((e,index)=>
  {
  e.deadline?e.deadline=new Date(this.calculatedeadline(e).returneddate).getTime():
  this.reclamationseme[index].deadline=new Date(this.calculatedeadline(e).returneddate).getTime()
  })
 /* const sort = new Sort();
  this.reclamationseme=this.reclamationseme.sort(sort.startSort('created','asc',''));*/
}
else if(listraclamations==this.reclamationsonus)
{
  this.reclamationsonus.forEach((e,index)=>
  {
  e.deadline?e.deadline=new Date(this.calculatedeadline(e).returneddate).getTime():
  this.reclamationsonus[index].deadline=new Date(this.calculatedeadline(e).returneddate).getTime()
  })
 /* const sort = new Sort();
  this.reclamationseme=this.reclamationseme.sort(sort.startSort('created','asc',''));*/
}
else if(listraclamations==this.reclamationsacq)
{
  this.reclamationsacq.forEach((e,index)=>
  {
  e.deadline?e.deadline=new Date(this.calculatedeadline(e).returneddate).getTime():
  this.reclamationsacq[index].deadline=new Date(this.calculatedeadline(e).returneddate).getTime()
  })
 /* const sort = new Sort();
  this.reclamationseme=this.reclamationseme.sort(sort.startSort('created','asc',''));*/
}
else if(listraclamations==this.reclamationscomite)
{
  this.reclamationscomite.forEach((e,index)=>
  {
  e.deadline?e.deadline=new Date(this.calculatedeadline(e).returneddate).getTime():
  this.reclamationscomite[index].deadline=new Date(this.calculatedeadline(e).returneddate).getTime()
  })
 /* const sort = new Sort();
  this.reclamationseme=this.reclamationseme.sort(sort.startSort('created','asc',''));*/
}
  }
/*showdeadlinetd(rec:Reclamation):boolean
  {
    if(rec.statut.length>1&&this.user.usertype!='Clientpor'&&this.user.usertype!='Clientcomm')
    {
    //@ts-ignore
    let statuts=rec.statut.filter(e=>!e.etat)
    //@ts-ignore
    let state= statuts[statuts.length-1].item
    //@ts-ignore
    let state1= statuts[statuts.length-2].item

    if(state=='rejetée'&&state1=='rejetée')
    {
      return true
    }
    else if(state=='rejetée'&&state1=='pré-arbitrage rejetée')
    {
      return true
    }
    else 
    {
      return false
    }
    }
else 
{ 
  return false
}
  }*/
filtredreclamation(status:any):any
  {
    let filtredstatus=status.filter(e=>!e.etat)
    return filtredstatus
  }
filtermotif(reclamation:Reclamation):string
{
  let returned:string
  //@ts-ignore
  let mot=reclamation.statut.find(e=>e.motif)
    //@ts-ignore
mot?returned=mot.motif:returned=null
  //@ts-ignore
  return returned
}
addHours(date:Date) {
    date.setTime(date.getTime() * 60 * 60 * 1000);

    return date;
  }  
calculaterecnumber():number
{
  this.reclamationnumber=this.reclamations.length+this.reclamationsacq.length+this.reclamationseme.length+this.reclamationsonus.length+this.reclamationscomite.length
  return this.reclamationnumber
}
onTabClick(event) {
   
}
async openrecbox()
{
  let checkboxlist=[]
  this.filtreditemschecked=[]
/*  this.reclamationseme=this.reclamationseme.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
  this.reclamations=this.reclamations.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
  this.reclamationsacq=this.reclamationsacq.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
  this.reclamationsonus=this.reclamationsonus.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
  this.reclamationscomite=this.reclamationscomite.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());*/

  for (let i = 0; i < this.paginatedreclamations.length ; i++) 
  {
    var checkbox:any = document.getElementById('checkreclamations'+`${i}`);  
   checkbox?checkbox.checked==true? 
   (checkboxlist.push(checkbox.checked),
   this.filtreditemschecked.push(this.reclamations[i]))
   :''
   :''
  }
  for (let i = 0; i < this.paginatedreclamationsacq.length ; i++) 
  {
    var checkbox:any = document.getElementById('checkreclamationsacq'+`${i}`);  
   checkbox?checkbox.checked==true?
   (checkboxlist.push(checkbox.checked),
   this.filtreditemschecked.push(this.reclamationsacq[i]))
   :''
   :''
  }
  for (let i = 0; i < this.paginatedreclamationseme.length ; i++) 
  {
    var checkbox:any = document.getElementById('checkreclamationseme'+`${i}`);  
   checkbox?checkbox.checked==true?
   (checkboxlist.push(checkbox.checked),
   this.filtreditemschecked.push(this.reclamationseme[i]))
   :''
   :''
  }
  for (let i = 0; i < this.paginatedreclamationsonus.length ; i++) 
  {
    var checkbox:any = document.getElementById('checkreclamationsonus'+`${i}`);  
   checkbox?checkbox.checked==true?
   (checkboxlist.push(checkbox.checked),
   this.filtreditemschecked.push(this.reclamationsonus[i]))
   :''
   :''
  }
  for (let i = 0; i < this.paginatedreclamationscomite.length ; i++) 
  {
    var checkbox:any = document.getElementById('checkreclamationscomite'+`${i}`);  
   checkbox?checkbox.checked==true?
   (checkboxlist.push(checkbox.checked),
   this.filtreditemschecked.push(this.reclamationscomite[i]))
   :''
   :''
  }
  //console.log(this.filtreditemschecked)
  if (checkboxlist.length==0){
    alert('veuillez sélectionner au moins une réclamation')
  }
  else if(!this.samestate()){
    alert('vous ne pouvez pas effectuer un traitement par lot sur des réclamations qui n\'ont pas le même statut')
  }
  else if(!this.verifycapabilitytodecideaction()){
    alert('action non permise à ce stade')
  }
  else
  {
  this.transactions=[]
  this.filtreditemschecked.forEach(
    element => element.transactions.forEach(e=>this.transactions.push(e))
  )
  this.displaybox='block'
  }

 
}
//functions for recs treatment
samestate():boolean
{
  let allstatus=[]
  let samestate=false
  for (let i = 0; i < this.filtreditemschecked.length ; i++) 
  {
    allstatus.push(this.filtreditemschecked[i].statut[this.filtreditemschecked[i].statut.length-1].item)
  }
  allstatus= allstatus.filter((obj, index) => {
    return index === allstatus.findIndex(o => obj === o);
  });
  allstatus.length==1?samestate=true:samestate=false
  return samestate 
}
changeaction(e)
{
  this.showvalidationbutton=true
  this.showform=true
  this.selectedaction = e.target.value
  this.selectedaction=='chb émis'?this.showmotif=true:this.showmotif=false
//this.selectedaction=='notification'?(this.commvalue=true,this.showform=true):(this.commvalue=false,this.showform=false)
}
dateaction()
{
this.commun.getcurrenttime().then(
  (response:number)=>{
    this.actiondate=response
  }
)
}
availableactions():any
{
let actions=[]
//@ts-ignore
let effectivestatus= this.filtreditemschecked[0].statut.filter(e=>!e.etat)
let checkstatut=effectivestatus?.find(e=>e.item=='chb émis')
if (checkstatut)
{
if(this.modeworkflow.find(e=>e.code==checkstatut.motif.substring(0,4))?.mode=='collab')
{
  //décrire le workflow collab
  if(this.user.usertype!='Clientcomm'&&this.user.usertype!='Clientpor')
  {
    //@ts-ignore
    this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION==this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
    ?
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='crée'?
    actions.push('rechdoc','acceptée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rejetée'||effectivestatus[effectivestatus.length-1].item=='acceptée'?
actions.push():
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('acceptée','reponserechdoc','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'||effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('acceptée','clôturé'):
actions.push()
    :
    

    //@ts-ignore
this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION!=this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
?

//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='crée'||effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='crée'?
actions.push('rechdoc','chb émis','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3]?.item=='rejetée'&&effectivestatus[effectivestatus.length-4]?.item=='reponserechdoc'?
actions.push('chb émis','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('chb émis','clôturé','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('reponserechdoc'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='chb émis'?
actions.push('acceptée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='chb émis'?
actions.push('pré-arbitrage','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='rejetée'&&effectivestatus[effectivestatus.length-4]?.item=='chb émis'?
actions.push('pré-arbitrage','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='reponserechdoc'?
actions.push('chb émis','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage'?
actions.push('pré-arbitrage rejetée','acceptée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage rejetée'?
actions.push('rejetée','arbitrage'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='pré-arbitrage rejetée'?
actions.push('clôturé','arbitrage'):

//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage'?
actions.push('arbitrage rejeté','arbitrage accepté'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage rejeté'&&this.role=='admincomite'?
actions.push('Arbitrage fav. émetteur','Arbitrage Fav. acquéreur'):
(actions.push(),this.loading=false)
:(actions.push(),this.loading=false)
    /* await Swal.fire({
      title: 'Veuillez choisir entre les alternatives suivantes!',
      input: 'select',
      inputLabel: 'Statut',
      inputValue: '',
      inputPlaceholder: "Selectionner un statut",
      returnInputValueOnDeny: true,
      icon: 'info',
      showCloseButton:true,
    //  html: `<button type="button" class="swal2-input" (click)="reloadPage()">reload </button>`,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#555',
      confirmButtonText: 'valider',
      cancelButtonText: 'Annuler',
      denyButtonText: 'rejeter',
      inputOptions: {
          encours: "encours",
          acceptée: "acceptée",
         /* CHBemis: "chb émis",
          Repersentée: "repersentée",
          Relancée: "relancée",
          Prearb: "pre-arb",
          Prearbrejetée: "pre-arb rejetée",
          arbitrage: "arbitrage",
          arbitragefavemetteur: "Arbitrage fav. émetteur",
          ArbitrageFavacquéreur: "Arbitrage Fav. acquéreur",*/
      }
  else
  {
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'?
    actions.push('relancée'):
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='pré-arbitrage rejetée'?
    actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='crée'?
     actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='reponserechdoc'?
     actions.push('relancée'):
    (actions.push(),this.loading=false)
   /* this.filtreditemschecked[0].changements=this.this.filtreditemschecked[0].changements
    this.recserv.savereclamationById(this.filtreditemschecked[0]._id, this.filtreditemschecked[0]).then(
      (data:any) => {
        console.log(data)
        this.loading = false;
       this.reloadPage();
      },
      (error) => {
        this.loading = false;   
      } 
    );*/
  }
}
else if(this.modeworkflow.find(e=>e.code==checkstatut.motif.substring(0,4))?.mode=='alloc')
{
  //décrire le workflow alloc
  if(this.user.usertype!='Clientcomm'&&this.user.usertype!='Clientpor')
  {
    //@ts-ignore
    this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION==this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
    ?
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='crée'?
    actions.push('rechdoc','acceptée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rejetée'||effectivestatus[effectivestatus.length-1].item=='acceptée'?
actions.push():
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('acceptée','reponserechdoc','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'||effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('acceptée','clôturé'):
actions.push()
    :
    

    //@ts-ignore
this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION!=this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
?

//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='crée'||effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='crée'?
actions.push('rechdoc','chb émis','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3]?.item=='rejetée'&&effectivestatus[effectivestatus.length-4]?.item=='reponserechdoc'?
actions.push('chb émis','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('chb émis','clôturé','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('reponserechdoc'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='chb émis'?
actions.push('acceptée','pré-arbitrage'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage'?
actions.push('pré-arbitrage acceptée','pré-arbitrage rejetée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='pré-arbitrage'?
actions.push('pré-arbitrage rejetée','clôturé','pré-arbitrage acceptée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage rejetée'?
actions.push('arbitrage'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage'?
actions.push('arbitrage rejeté','arbitrage accepté'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage rejeté'&&this.role=='admincomite'?
actions.push('Arbitrage fav. émetteur','Arbitrage Fav. acquéreur'):
(actions.push(),this.loading=false)
:(actions.push(),this.loading=false)
    /* await Swal.fire({
      title: 'Veuillez choisir entre les alternatives suivantes!',
      input: 'select',
      inputLabel: 'Statut',
      inputValue: '',
      inputPlaceholder: "Selectionner un statut",
      returnInputValueOnDeny: true,
      icon: 'info',
      showCloseButton:true,
    //  html: `<button type="button" class="swal2-input" (click)="reloadPage()">reload </button>`,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#555',
      confirmButtonText: 'valider',
      cancelButtonText: 'Annuler',
      denyButtonText: 'rejeter',
      inputOptions: {
          encours: "encours",
          acceptée: "acceptée",
         /* CHBemis: "chb émis",
          Repersentée: "repersentée",
          Relancée: "relancée",
          Prearb: "pre-arb",
          Prearbrejetée: "pre-arb rejetée",
          arbitrage: "arbitrage",
          arbitragefavemetteur: "Arbitrage fav. émetteur",
          ArbitrageFavacquéreur: "Arbitrage Fav. acquéreur",*/
      }
  else
  {
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'?
    actions.push('relancée'):
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='pré-arbitrage'?
    actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='crée'?
     actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='reponserechdoc'?
     actions.push('relancée'):
    (actions.push(),this.loading=false)
   /* this.reclamation.changements=this.this.reclamation.changements
    this.recserv.savereclamationById(this.reclamation._id, this.reclamation).then(
      (data:any) => {
        console.log(data)
        this.loading = false;
       this.reloadPage();
      },
      (error) => {
        this.loading = false;   
      } 
    );*/
  }
}
}
else
{
  if(this.user.usertype!='Clientcomm'&&this.user.usertype!='Clientpor')
  {
    //@ts-ignore
    this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION==this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
    ?
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='crée'?
    actions.push('rechdoc','acceptée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rejetée'||effectivestatus[effectivestatus.length-1].item=='acceptée'?
actions.push():
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('acceptée','reponserechdoc','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'||effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('acceptée','clôturé'):
actions.push()
    :
    

    //@ts-ignore
this.filtreditemschecked[0].transactions[0].ACQUIRERBANKIDENTIFICATION!=this.filtreditemschecked[0].transactions[0].ISSUERBANKIDENTIFICATION
?

//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='crée'||effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='crée'?
actions.push('rechdoc','chb émis','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3]?.item=='rejetée'&&effectivestatus[effectivestatus.length-4]?.item=='reponserechdoc'?
actions.push('chb émis','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='reponserechdoc'?
actions.push('chb émis','clôturé','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rechdoc'?
actions.push('reponserechdoc'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='chb émis'?
actions.push('acceptée','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='chb émis'?
actions.push('pré-arbitrage','rejetée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='rejetée'&&effectivestatus[effectivestatus.length-4]?.item=='chb émis'?
actions.push('pré-arbitrage','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-3].item=='reponserechdoc'?
actions.push('chb émis','clôturé'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage'?
actions.push('pré-arbitrage rejetée','acceptée'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='pré-arbitrage rejetée'?
actions.push('rejetée','arbitrage'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='relancée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='pré-arbitrage rejetée'?
actions.push('clôturé','arbitrage'):

//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage'?
actions.push('arbitrage rejeté','arbitrage accepté'):
//@ts-ignore
effectivestatus[effectivestatus.length-1].item=='arbitrage rejeté'&&this.role=='admincomite'?
actions.push('Arbitrage fav. émetteur','Arbitrage Fav. acquéreur'):
(actions.push(),this.loading=false)
:(actions.push(),this.loading=false)
    /* await Swal.fire({
      title: 'Veuillez choisir entre les alternatives suivantes!',
      input: 'select',
      inputLabel: 'Statut',
      inputValue: '',
      inputPlaceholder: "Selectionner un statut",
      returnInputValueOnDeny: true,
      icon: 'info',
      showCloseButton:true,
    //  html: `<button type="button" class="swal2-input" (click)="reloadPage()">reload </button>`,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#555',
      confirmButtonText: 'valider',
      cancelButtonText: 'Annuler',
      denyButtonText: 'rejeter',
      inputOptions: {
          encours: "encours",
          acceptée: "acceptée",
         /* CHBemis: "chb émis",
          Repersentée: "repersentée",
          Relancée: "relancée",
          Prearb: "pre-arb",
          Prearbrejetée: "pre-arb rejetée",
          arbitrage: "arbitrage",
          arbitragefavemetteur: "Arbitrage fav. émetteur",
          ArbitrageFavacquéreur: "Arbitrage Fav. acquéreur",*/
      }
  else
  {
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='rejetée'?
    actions.push('relancée'):
    //@ts-ignore
    effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='pré-arbitrage rejetée'?
    actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='crée'?
     actions.push('relancée'):
     //@ts-ignore
     effectivestatus[effectivestatus.length-1].item=='rejetée'&&effectivestatus[effectivestatus.length-2].item=='reponserechdoc'?
     actions.push('relancée'):
    (actions.push(),this.loading=false)
   /* this.filtreditemschecked[0].changements=this.this.filtreditemschecked[0].changements
    this.recserv.savereclamationById(this.filtreditemschecked[0]._id, this.filtreditemschecked[0]).then(
      (data:any) => {
        console.log(data)
        this.loading = false;
       this.reloadPage();
      },
      (error) => {
        this.loading = false;   
      } 
    );*/
  }
}
return actions
}
onchangegroupe(value:any):any
{
  let availablesfamilles=[]
  this.familles.forEach(e=>e.groupe==value?availablesfamilles.push(e.fam):'')
  availablesfamilles= availablesfamilles.filter((obj, index) => {
    return index === availablesfamilles.findIndex(o => obj === o);
  });
return availablesfamilles
}
async verifychb()
{
  let currentdate=this.currentdate
  let date2=currentdate
  //@ts-ignore
  this.motifs[0]?.groupe.find(ele=>ele.code==this.reclamationform.get('motif').value.substring(0,4))?date2=this.motifs[0]?.groupe.find(ele=>ele.code==this.reclamationform.get('motif').value.substring(0,4)).delai*24*3600*1000:date2=1
  for await (const element of this.filtreditemschecked) {
      //@ts-ignore
  if(new Date(element.transactions[0].PROCESSINGDATE).getTime()+date2<=currentdate)
  {
   alert('Délais réglementaires de '+`${this.motifs[0]?.groupe.find(ele=>ele.code==this.reclamationform.get('motif').value.substring(0,4)).delai} jours dépassés au niveau de la réclamation avec le code ${element.ref}${element.refprefixe}  . Action impossible.`  )
  this.reclamationform.reset()
 }
  }

}
onchangefamille(value:any):any
{
  this.availablesmotifs=[]
  this.motifs.forEach(e=>e.fam==value?this.availablesmotifs.push({id:e.id,intitule:e.intitule}):'')
  this.availablesmotifs= this.availablesmotifs.filter((obj, index) => {
    return index === this.availablesmotifs.findIndex(o => obj === o);
  });
return this.availablesmotifs
}
async onSend(user: User) {
  this.submitted=true
  let docoblig: any;
  // @ts-ignore
  docoblig = this.motifs[0]?.groupe.find(ele => ele.code == this.reclamationform.get('motif').value.substring(0, 4))
    ? this.motifs[0]?.groupe.find(ele => ele.code == this.reclamationform.get('motif').value.substring(0, 4)).contientfichier
    : 'Non';

  if (!this.reclamationform.get('motif').value && this.showmotif) {
    return (this.loading = false, this.submitted = false, alert('veuillez indiquer le motif de chargeback'));
  } else if (this.uploadedfiles.length == 0 && docoblig == 'Oui' && this.selectedaction == 'chb émis') {
    return (this.loading = false, this.submitted = false, alert('le rattachement d\'un document est obligatoire'));
  } else {
    try {
      const time = await this.commun.getcurrenttime();

      // Iterate over `filtreditemschecked` using `for await of` to handle async operations
      for await (const element of this.filtreditemschecked) {
        const reclamation: Reclamation = await this.recserv.getReclamationdataById(element._id) as Reclamation;
        this.loading = true;
        this.submitted = true;
        reclamation.statut = element.statut;

        // Wait for `setstatutmetier` or `setstatutporteur` to finish before proceeding
        if (user.usertype !== 'Clientcomm' && user.usertype !== 'Clientpor') {
          await this.setstatutmetier(reclamation, this.selectedaction, time);
        } else {
          await this.setstatutporteur(reclamation, this.selectedaction, time);
        }
      }
      this.submitted=false
      // All async operations in the loop have finished
      this.closePopup();
      this.refreshrecs();

      // Show success message
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'réclamation(s) traitée(s) avec succès!',
        showConfirmButton: false,
        timer: 6000
      });
    } catch (error) {
      console.error("Error during processing:", error);
      // Handle any error that might have occurred during async operations
      this.loading = false;
      this.submitted = false;
    }
  }
}

async setstatutmetier(reclamation?:Reclamation,chosenstatut?:any,time?:any)
{
  //@ts-ignore
  let effectivestatus= reclamation.statut.filter(e=>!e.etat)
              //@ts-ignore
              reclamation.statut.push({
                //@ts-ignore
      item: chosenstatut!='notification'&&chosenstatut!='notifiercommercant'?chosenstatut:effectivestatus[effectivestatus.length-1].item,
                //@ts-ignore
      date: time,
       //@ts-ignore
etat:chosenstatut=='notification'?'notification':chosenstatut=='notifiercommercant'?'notification commerçant':'',
     //@ts-ignore
       acteur:this.user.usertype,
         //@ts-ignore
       role:reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.user.banque&&this.user.usertype!='comite arbitrage'?'émetteur':
         //@ts-ignore
       reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION==this.user.banque&&this.user.usertype!='comite arbitrage'?'acquireur':
        //@ts-ignore
        this.user.role=='usercomite'?'usercomite':
        //@ts-ignore
        this.user.role=='admincomite'?'admincomite':
        'autre',
     //@ts-ignore
       commentaire :this.reclamationform.get('commentaire').value,
     //@ts-ignore
       motif :this.reclamationform.get('motif').value,
        //@ts-ignore
        famille :this.reclamationform.get('famille').value,
        //@ts-ignore
      groupe :this.reclamationform.get('groupe').value,
                 //@ts-ignore
      identity :this.user.firstname+''+this.user.lastname,
     //@ts-ignore
       ficheUrl : []
     })
    /* result.value?reclamation.changements.push(
       //@ts-ignore
       {
                 //@ts-ignore
         id:reclamation.changements.length==0?1:
                   //@ts-ignore
         reclamation.changements[reclamation.changements.length-1].id+1,
         //@ts-ignore
       //  commentaire :result.value,
                 //@ts-ignore
         date:time,
                 //@ts-ignore
         acteur:this.user.usertype,
       }
     ):''*/
            //@ts-ignore
  let role=reclamation.statut[reclamation.statut.length-1].role
  //@ts-ignore
  let motif=''
  //@ts-ignore
  effectivestatus.find(e=>e.motif!='')?motif= effectivestatus.find(e=>e.motif!='').motif:motif=''
       //@ts-ignore
let checkstatut=effectivestatus?.find(e=>e.item=='chb émis')
if (checkstatut)
{
//@ts-ignore
if(this.modeworkflow.find(e=>e.code==checkstatut.motif.substring(0,4))?.mode=='collab')
{
  if(chosenstatut=='chb émis')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='chargebackemis'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE=reclamation.transactions[0].OPERATIONCODE
      //@ts-ignore
  chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'15':reclamation.transactions[0].TRANSACTIONCODE=='06'?'16':reclamation.transactions[0].TRANSACTIONCODE=='07'?'17':reclamation.transactions[0].TRANSACTIONCODE=='08'?'18':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=this.reclamationform.get('motif').value.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='1'
    //@ts-ignore
  let message = this.reclamationform.get('motif').value.substring(3, 25);
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{this.loading=false}
   )
  }
  //@ts-ignore
  else  if(chosenstatut=='rejetée'&&role=='acquireur')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='represente'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE=reclamation.transactions[0].OPERATIONCODE
      //@ts-ignore
    chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'05':reclamation.transactions[0].TRANSACTIONCODE=='06'?'06':reclamation.transactions[0].TRANSACTIONCODE=='07'?'07':reclamation.transactions[0].TRANSACTIONCODE=='08'?'08':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='2'
  //@ts-ignore
  let message = motif.substring(3, 25);
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
    chargeback.presntmentindicator='R'
    chargeback.FILLERCHARGEBACK='   '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{}
   )
  }
  //@ts-ignore
  else if(chosenstatut=='acceptée'&&effectivestatus[effectivestatus.length-1].item=='pré-arbitrage')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='acceptationprearb'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'15':reclamation.transactions[0].TRANSACTIONCODE=='06'?'16':reclamation.transactions[0].TRANSACTIONCODE=='07'?'17':reclamation.transactions[0].TRANSACTIONCODE=='08'?'18':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='2'
    //@ts-ignore
  let message = "1pre-arb accepte";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{}
   )
  }
  else if(chosenstatut=='arbitrage accepté')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='acceptationarb'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'15':reclamation.transactions[0].TRANSACTIONCODE=='06'?'16':reclamation.transactions[0].TRANSACTIONCODE=='07'?'17':reclamation.transactions[0].TRANSACTIONCODE=='08'?'18':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='3'
    //@ts-ignore
  let message = "2arbitrage accepte";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
           this.loading = false;   
         } 
       );
     }
   ).catch(
     ()=>{this.loading=false}
   )
  }
  else if(chosenstatut=='Arbitrage fav. émetteur')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='arbemetteur'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'15':reclamation.transactions[0].TRANSACTIONCODE=='06'?'16':reclamation.transactions[0].TRANSACTIONCODE=='07'?'17':reclamation.transactions[0].TRANSACTIONCODE=='08'?'18':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='4'
      //@ts-ignore
  let message = "3arbitrage fav Emetteur";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{}
   )
  }
else 
{
 await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
   (data:any) => {
//       this.getNavigation('open-detail/'+reclamation._id+'/all');
    },
   (error) => {
   } 
 );
} 
}
else //@ts-ignore
if(this.modeworkflow.find(e=>e.code==checkstatut.motif.substring(0,4))?.mode=='alloc')
{
  if(chosenstatut=='chb émis')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='chargebackemis'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE=reclamation.transactions[0].OPERATIONCODE
      //@ts-ignore
  chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'15':reclamation.transactions[0].TRANSACTIONCODE=='06'?'16':reclamation.transactions[0].TRANSACTIONCODE=='07'?'17':reclamation.transactions[0].TRANSACTIONCODE=='08'?'18':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=this.reclamationform.get('motif').value.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='1'
    //@ts-ignore
  let message = this.reclamationform.get('motif').value.substring(3, 25);
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{this.loading=false}
   )
  }
  //@ts-ignore
  else if(chosenstatut=='acceptée'&&effectivestatus[effectivestatus.length-1].item=='pré-arbitrage')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='acceptationprearb'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'05':reclamation.transactions[0].TRANSACTIONCODE=='06'?'06':reclamation.transactions[0].TRANSACTIONCODE=='07'?'07':reclamation.transactions[0].TRANSACTIONCODE=='08'?'08':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='2'
    //@ts-ignore
  let message = "1pre-arb accepte";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{}
   )
  }
  else if(chosenstatut=='arbitrage accepté')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='acceptationarb'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'05':reclamation.transactions[0].TRANSACTIONCODE=='06'?'06':reclamation.transactions[0].TRANSACTIONCODE=='07'?'07':reclamation.transactions[0].TRANSACTIONCODE=='08'?'08':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='3'
    //@ts-ignore
  let message = "2arbitrage accepte";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
           this.loading = false;   
         } 
       );
     }
   ).catch(
     ()=>{this.loading=false}
   )
  }
  else if(chosenstatut=='Arbitrage fav. acquireur')
  {
    const chargeback:Chargeback= new Chargeback()
    chargeback.event='arbacquireur'
    //@ts-ignore
    chargeback.MERCHANTIDENTIFICATION=reclamation.transactions[0].MERCHANTIDENTIFICATION
      //@ts-ignore
    chargeback.BATCHIDENTIFICATION=reclamation.transactions[0].BATCHIDENTIFICATION
      //@ts-ignore
    chargeback.INVOICENUMBER=reclamation.transactions[0].INVOICENUMBER
      //@ts-ignore
    chargeback.CARDHOLDERNUMBER=reclamation.transactions[0].CARDHOLDERNUMBER
      //@ts-ignore
    chargeback.MERCHANTSECTOR=reclamation.transactions[0].MERCHANTSECTOR
      //@ts-ignore
    chargeback.CHANNELTRANSACTIONID=reclamation.transactions[0].CHANNELTRANSACTIONID
      //@ts-ignore
    chargeback.OPERATIONCODE='C'
      //@ts-ignore
      chargeback.TRANSACTIONCODE=reclamation.transactions[0].TRANSACTIONCODE=='05'?'05':reclamation.transactions[0].TRANSACTIONCODE=='06'?'06':reclamation.transactions[0].TRANSACTIONCODE=='07'?'07':reclamation.transactions[0].TRANSACTIONCODE=='08'?'08':'  '
      //@ts-ignore
    chargeback.TRANSACTIONAMOUNT=reclamation.transactions[0].TRANSACTIONAMOUNT
      //@ts-ignore
    chargeback.CARDEXPIRYDATE=reclamation.transactions[0].CARDEXPIRYDATE
      //@ts-ignore
    chargeback.PROCESSINGDATE=reclamation.transactions[0].PROCESSINGDATE
      //@ts-ignore
    chargeback.TRANSACTIONDATE=reclamation.transactions[0].TRANSACTIONDATE
      //@ts-ignore
    chargeback.AUTHORIZATIONCODE=reclamation.transactions[0].AUTHORIZATIONCODE
      //@ts-ignore
    chargeback.REMITTANCEDATE=reclamation.transactions[0].REMITTANCEDATE
      //@ts-ignore
    chargeback.MERCHANTCATEGORIECODE=reclamation.transactions[0].MERCHANTCATEGORIECODE
      //@ts-ignore
    chargeback.FILLER=reclamation.transactions[0].FILLER
      //@ts-ignore
    chargeback.ACQUIRERBANKIDENTIFICATION=reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.LOCALCARDSYSTEMNETWORK=reclamation.transactions[0].LOCALCARDSYSTEMNETWORK
      //@ts-ignore
    chargeback.ISSUERBANKIDENTIFICATION=reclamation.transactions[0].ISSUERBANKIDENTIFICATION
      //@ts-ignore
    chargeback.ACQUIRERREFERENCENUMBER=reclamation.transactions[0].ACQUIRERREFERENCENUMBER
    //@ts-ignore
    chargeback.TRANSACTIONORDERUSAGECODE=reclamation.transactions[0].TRANSACTIONORDERUSAGECODE
      //@ts-ignore
    chargeback.CHARGEBACKREASONCODE=motif.substring(0,2)
      //@ts-ignore
    chargeback.CHARGEBACKTRANSACTIONCYCLE='4'
      //@ts-ignore
  let message = "3arbitrage fav acquireur";
  if (message.length < 22) {
      message = message.padEnd(22, ' ');
  }
  chargeback.MESSAGE = message;
      //@ts-ignore
    chargeback.SETTLEMENTAMOUNT=reclamation.transactions[0].SETTLEMENTAMOUNT
      //@ts-ignore
    chargeback.TRANSACTIONTIME=reclamation.transactions[0].TRANSACTIONTIME
      //@ts-ignore
    chargeback.FILLERCHARGEBACK='    '
    chargeback.finchargeback='X'
    await this.chargebackservice.create(chargeback).then(
     async (data) => {
       await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
         (data:any) => {
  //         this.getNavigation('open-detail/'+reclamation._id+'/all');
          },
         (error) => {
         } 
       );
     }
   ).catch(
     ()=>{}
   )
  }
else 
{
 await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
   (data:any) => {
//       this.getNavigation('open-detail/'+reclamation._id+'/all');
    },
   (error) => {
   } 
 );
} 
}
}
else 
{
 await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
   (data:any) => {
//       this.getNavigation('open-detail/'+reclamation._id+'/all');
    },
   (error) => {
   } 
 );
} 

}
async setstatutporteur(reclamation:Reclamation,chosenstatut?:string,time?:any)
{
    //@ts-ignore
    let effectivestatus= reclamation.statut.filter(e=>!e.etat)
         //@ts-ignore
         reclamation.statut.push({
          //@ts-ignore
          item: chosenstatut!='réponse'?chosenstatut:effectivestatus[effectivestatus.length-1].item,
          //@ts-ignore
date: time,
 //@ts-ignore
etat:chosenstatut=='réponse'?'réponse commerçant':'',
//@ts-ignore
 acteur:this.user.usertype,
//@ts-ignore
 commentaire :this.reclamationform.get('commentaire').value,
//@ts-ignore
 motif :this.reclamationform.get('motif').value,
  //@ts-ignore
  famille :this.reclamationform.get('famille').value,
  //@ts-ignore
groupe :this.reclamationform.get('groupe').value,
//@ts-ignore
 ficheUrl : []
})
await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
  (data:any) => {

 //   this.getNavigation('open-detail/'+reclamation._id+'/all');
  },
  (error) => {
  } 
);
}
filtervalue(value:string):string
{
  let view:string
  value=='T'?view='TPE/ECOM':
  value=='G'?view='GAB':
  value==''||value=='O'||value=='M'?view='Manual':
  value=='R'?view='Recharge GAB':
  value=='Z'?view='Mobile':
  value=='05'?view='Achat':
  value=='06'?view='crédit':
  value=='07'?view='Cash Advance':
  value=='08'?view='Retrait':
  value=='15'?view='Impayé GAB':
  value=='17'?view='Impayé CASH ADVANCE':
  value=='18'?view='Impayé GAB':
  value=='1'?view='1st CHARGEBACK':
  value=='2'?view='2nd CHARGEBACK':
  value
  return view
}
onImagePick(event: Event) {
  this.uploadedfiles=[]
  for (var i = 0; i < (event.target as HTMLInputElement).files.length; i++) {
   // this.reclamationform.get('file').patchValue(file);
   // this.reclamationform.get('file').updateValueAndValidity();
   const file = (event.target as HTMLInputElement).files[i];
   this.uploadedfiles.push(file)
   const reader = new FileReader();
   reader.onload = () => {
     if (this.uploadedfiles.length>0) {
       this.imagePreview = reader.result as string;
       this.fileUploaded = true;
     } else {
       this.imagePreview = null;
     }
   };
   reader.readAsDataURL(file);
   
  }

}
closePopup()
{
  this.displaybox = "none";
  if (this.filePicker) {
    // Access the nativeElement and reset its value
    this.filePicker.nativeElement.value = '';
  }
  this.selectedaction=''
  this.showform=false
  this.showmotif=false
  this.fileUploaded=false
  this.reclamationform.reset()
  this.uploadedfiles=[]
}
sort()
{
  this.motifs.sort()
}
filterallreclamations() {
  this.showfilterbutton = false;
  this.showreinitbutton = true;
  this.showsearchform = false;

  let allrecs: any[] = [];
  allrecs = allrecs.concat(this.reclamations, this.reclamationsacq, this.reclamationseme, this.reclamationsonus, this.reclamationscomite);

  allrecs = allrecs
    .filter(e => !this.option0Value || (e.transactions && e.transactions[0] && this.option0Value == e.transactions[0].MERCHANTIDENTIFICATION))
    .filter(e => !this.option1Value || (e.transactions && e.transactions[0] && this.option1Value == e.transactions[0].ACQUIRERBANKIDENTIFICATION))
    .filter(e => !this.option3Value || (e.transactions && e.transactions[0] && this.option3Value + '   ' == e.transactions[0].CARDHOLDERNUMBER))
    .filter(e => !this.option2Value || (e.transactions && e.transactions[0] && new Date(this.option2Value) <= new Date(e.transactions[0].TRANSACTIONDATE)))
    .filter(e => !this.option11Value || (e.transactions && e.transactions[0] && new Date(this.option11Value) >= new Date(e.transactions[0].TRANSACTIONDATE)))
    .filter(e => !this.option5Value || (this.option5Value == (e.ref + e.refprefixe)))
    .filter(e => !this.option6Value || (new Date(this.option6Value) <= new Date(e.created)))
    .filter(e => !this.option12Value || (new Date(this.option12Value) >= new Date(e.created)))
    .filter(e => !this.option7Value || (
      e.statut && e.statut.length > 0 &&
      (this.option7Value != 'représentée' ? this.option7Value == e.statut[e.statut.length - 1].item :
        (e.statut.length > 1 && e.statut[e.statut.length - 1].item == 'rejetée' && e.statut[e.statut.length - 2].item == 'chb émis'))
    ))
    .filter(e => !this.option8Value || (e.statut && e.statut.length > 0 && new Date(this.option8Value) <= new Date(e.statut[e.statut.length - 1].date)))
    .filter(e => !this.option13Value || (e.statut && e.statut.length > 0 && new Date(this.option13Value) >= new Date(e.statut[e.statut.length - 1].date)))
    .filter(e => !this.option9Value || (e.statut && e.statut.find(el => el.motif == this.option9Value)))
    .filter(e => !this.option10Value || (this.option10Value == e.userId));
  if (this.user.usertype == 'Clientpor' || this.user.usertype == 'Clientcomm') {
    this.reclamations = allrecs;
  } else if (this.user.usertype != 'Clientpor' && this.user.usertype != 'Clientcomm' && this.user.usertype != 'comite arbitrage') {
    this.reclamationsonus = allrecs.filter(e => e.transactions && e.transactions[0] && e.transactions[0].ACQUIRERBANKIDENTIFICATION == e.transactions[0].ISSUERBANKIDENTIFICATION);
    this.updatePaginatedList(this.reclamationsonus)
    this.reclamationsacq = allrecs.filter(e => e.transactions && e.transactions[0] && e.transactions[0].ACQUIRERBANKIDENTIFICATION == this.user.banque && this.user.banque != e.transactions[0].ISSUERBANKIDENTIFICATION);
    this.updatePaginatedList(this.reclamationsacq)
    this.reclamationseme = allrecs.filter(e => e.transactions && e.transactions[0] && this.user.banque == e.transactions[0].ISSUERBANKIDENTIFICATION && this.user.banque != e.transactions[0].ACQUIRERBANKIDENTIFICATION);
    this.updatePaginatedList(this.reclamationseme) 
  } else if (this.user.usertype == 'comite arbitrage') {
    this.reclamationscomite = allrecs.filter(el => el.statut && el.statut.length > 0 && el.statut[el.statut.length - 1].item == 'arbitrage rejeté');
    this.updatePaginatedList(this.reclamationscomite)
  }
}

          click1()
          {
          }
          refreshrecs()
          {
            /*this.reclamations=[]
            this.reclamationsacq=[]
            this.reclamationseme=[]
            this.reclamationsonus=[]*/
            this.showfilterbutton=true
            this.showreinitbutton=false
            this.showsearchform=true
            this.option0Value=this.option10Value=this.option11Value=this.option12Value=this.option13Value=this.option1Value
            =this.option2Value=this.option2Value=this.option3Value=this.option4Value=this.option5Value=this.option6Value=
            this.option7Value=this.option8Value=this.option9Value=undefined
            this.user.usertype=='Clientpor'?this.data.getmanyinfo(this.user.compte):
            this.user.usertype=='Metier'||this.user.usertype=='agence'?( this.recserv.getReclamationacq(this.banque),
            this.recserv.getReclamationeme(this.banque),this.recserv.getReclamationonus(this.banque),
            this.mot.getmotifreclamationss()):''
            this.recserv.getReclamationportbanque(this.cartes)
          }
          reloadPage (){
            window.location.reload();
            }
            deleterec(id){
              this.recserv.deleteReclamationdataById(id).then(
                res => {
                  this.user.usertype=='Clientpor'?this.data.getmanyinfo(this.user.compte):
                  this.user.usertype=='Metier'||this.user.usertype=='agence'?( this.recserv.getReclamationacq(this.banque),
                  this.recserv.getReclamationeme(this.banque),this.recserv.getReclamationonus(this.banque),
                  this.mot.getmotifreclamationss()):''
                  this.recserv.getReclamationportbanque(this.cartes)
                }
              )
            }
          ngOnDestroy(){
            this.motifsub?this.motifsub.unsubscribe():'';
            this.reclamationsacqSub?this.reclamationsacqSub.unsubscribe():'';
            this.reclamationsemeSub?this.reclamationsemeSub.unsubscribe():'';
            this.reclamationsonusSub?this.reclamationsonusSub.unsubscribe():'';

            this.reclamationsSub?this.reclamationsSub.unsubscribe():'';
            }
  }
  

  
  
  
  

 


